import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { usePeriscopeMetadata } from '@hooks';

import { MetadataContainer, MetadataEntry } from '@periscopes/general/metadata';
import { PeriscopePardotPageActionMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

export interface PardotPageActionMetadataTabProps {
	sonarObjectId: number;
}

export const PardotPageActionMetadataTab: React.FC<PardotPageActionMetadataTabProps> = ({ sonarObjectId }) => {
	const { loading, metadata } = usePeriscopeMetadata<PeriscopePardotPageActionMetadata>(
		sonarObjectId,
		SonarObjectType.PardotPageAction
	);

	const metadataEntries = useMemo(() => {
		if (!metadata) {
			return [];
		}

		const entries: MetadataEntry[] = [
			{
				label: COPY_SPECIFIC.PAGE_URL,
				type: 'string',
				value: metadata.pageUrl
			},
			{
				label: COPY_SPECIFIC.SCORE_CHANGE,
				type: 'string',
				value: metadata.scoreChange
			},
			{
				label: COPY_SPECIFIC.SCORING_CATEGORY,
				type: 'string',
				value: metadata.scoringCategory
			},
			{
				label: COPY_SPECIFIC.PRIORITY_PAGE,
				type: 'boolean',
				value: metadata.priorityPage
			},
			{
				label: COPY_SPECIFIC.CREATED_AT,
				type: 'string',
				value: metadata.createdAt
			},
			{
				label: COPY_SPECIFIC.CREATED_BY,
				type: 'string',
				value: metadata.createdBy
			},
			{
				label: COPY_SPECIFIC.UPDATED_AT,
				type: 'string',
				value: metadata.updatedAt
			},
			{
				label: COPY_SPECIFIC.UPDATED_BY,
				type: 'string',
				value: metadata.updatedBy
			}
		];

		return entries;
	}, [ metadata ]);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	return <MetadataContainer
		entries={ metadataEntries }
		title={ COPY_SPECIFIC.PAGE_ACTION_INFORMATION } />;
};
